export default __webpack_public_path__ + "static/media/green-clock.b7336a17.svg";